import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { storePlanogramRulesDataAtom, StorePlanogramRulesModalProps } from "./atoms";

export const useStorePlanogramRulesModal = () => {
  const { openModal } = useModals();
  const setStorePlanogramRulesData = useSetAtom(storePlanogramRulesDataAtom);

  const openStorePlanogramRules = (data: StorePlanogramRulesModalProps) => {
    setStorePlanogramRulesData(data);
    openModal("ModalStorePlanogramRules");
  };

  return { openStorePlanogramRules };
};
